export default __webpack_public_path__ + "static/media/hide.b1ef9edb.svg";